import { useEffect } from 'react';
import Style from './SubscriptionStatusPage.style';
import { Headline, Spinner } from 'Common';
import { TEXT } from 'locales/translations';
import { useDispatch, useSelector } from 'react-redux';
import { getUserPaymentInfosRequest } from 'redux/actions';
import {
  getUserPaymentDetails,
  hasSubscription,
  isUserPaymentInformationLoading,
  getActiveUserSubscription,
  getZppAttendances
} from 'redux/query';
import { NoSubscriptionContainer } from 'containers';
import { SubscriptionDetailTable, SubscriptionHint, UserBillingAddress } from 'Component';
import { UserPaymentMethodForm } from 'Component/UserPaymentMethodForm/UserPaymentMethodForm';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { linkHandler } from 'utils/linkHandler';

export const SubscriptionStatusPage = () => {
  const dispatch = useDispatch();
  const { provider, product, active, canceled } = useSelector(getUserPaymentDetails);
  const activeSubscription = useSelector(getActiveUserSubscription);
  const isLoading = useSelector(isUserPaymentInformationLoading);
  const isSubscripte = useSelector(hasSubscription);
  const userZppAttendances = useSelector(getZppAttendances);

  useEffect(() => {
    dispatch(getUserPaymentInfosRequest({ renewable: true }));
  }, []);

  const isSubscriptionOngoing = active && !canceled;

  return (
    <Style className="subscription-status">
      <Headline level={1} className="headline">
        Dein Abo
      </Headline>
      {isLoading ? (
        <Spinner />
      ) : isSubscripte && !!activeSubscription ? (
        <>
          <SubscriptionHint />
          <SubscriptionDetailTable />
          {provider === 'STRIPE' && (
            <>
              {isSubscriptionOngoing && !product.includes('Geschenk-Gutschein') && (
                <>
                  <UserPaymentMethodForm />
                  <UserBillingAddress />
                  <Row className="mt-5">
                    <Col xs={12} sm={6} className="subscription-status-title">
                      {TEXT.subscriptionStatusDetail.currentContract}
                    </Col>
                    <Col xs={12} sm={6}>
                      <Link
                        to={linkHandler.get('terminate')}
                        className="btn-link-underlined p-0 m-0 btn btn-secondary float-sm-right float-none mt-sm-2"
                      >
                        {TEXT.subscriptionStatusDetail.cancelContract}
                      </Link>
                    </Col>
                  </Row>
                </>
              )}
            </>
          )}
        </>
      ) : !!userZppAttendances.length ? (
        <div>
          <div className="pb-3">Du nutzt Balloon gerade ohne Abo</div>
        </div>
      ) : (
        <NoSubscriptionContainer />
      )}
    </Style>
  );
};
